import React from 'react';
import { useContext } from 'react';
import SimpleContext from './../context/SimpleContext';
import Shop from './Shop';

const Shops = () => {

    const context = useContext(SimpleContext);
    
    return ( 
        <div className='products'>
                {
                    context.Listt.length ? 
                    context.Listt.map(product =>
                        
                        product.map(pr => 
                            <div key={pr.id}>
                                <Shop 
                                key={pr.id}
                                name = {pr.name}
                                price = {pr.price}
                                slug = {pr.slug}
                                min = {pr.minimum}
                                max = {pr.maximum}
                                isvalid = {pr.status}
                                numUnit = {pr.number_in_unit}
                                unit = {pr.IsKilo}
                                lvlname = {pr.categoryArray}
                                /> 
                            </div>
                            )
                        
                    ):null
                }
            </div>
    );
}
 
export default Shops;